const UUID_PATH_SEGMENT = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
const NUMERIC_PATH_SEGMENT = /^\d+$/
const REQUEST_PATH_BASE_URL = "https://telemetry.invalid"

export const getTelemetryRequestPath = (url?: string): string | undefined => {
	if (!url) return undefined
	try {
		return new URL(url, REQUEST_PATH_BASE_URL).pathname
			.split("/")
			.map((segment) =>
				UUID_PATH_SEGMENT.test(segment) || NUMERIC_PATH_SEGMENT.test(segment)
					? ":id"
					: segment,
			)
			.join("/")
			.slice(0, 200)
	} catch {
		return undefined
	}
}
